import { ReactNode } from "react";
import { defaultProps } from "helpers/common";
import AlertTextBox, { AlertTextBoxProps } from "./AlertTextBox";
import { Stack, StackProps, SvgIcon, SvgIconProps } from "@mui/material";
import { CheckCircleOutlined, InfoOutlined, WarningAmberOutlined } from "@mui/icons-material";

export type AlertCardVariant = "success" | "error" | "warning" | "disabled";

export const variantStyles = {
    error: {
        color: "#FF006B",
        backgroundColor: "rgba(255, 0, 107, 0.08)",
    },
    success: {
        color: "#079E8D",
        backgroundColor: "rgba(9, 202, 180, 0.08)",
    },
    warning: {
        color: "#FF9472",
        backgroundColor: "rgba(255, 148, 114, 0.08)",
    },
    disabled: {
        color: "#6D83A3",
        backgroundColor: "rgba(109, 131, 163, 0.08)",
    },
};

const variantIcons = {
    error: InfoOutlined,
    success: CheckCircleOutlined,
    warning: WarningAmberOutlined,
    disabled: InfoOutlined,
};

export interface AlertCardProps {
    stackProps?: StackProps;
    alertTextBoxProps?: AlertTextBoxProps;
    variant?: AlertCardVariant;
    iconProps?: SvgIconProps;
    rightSlot?: ReactNode;
}

function AlertCard(props: AlertCardProps) {
    const variant = props.variant || "disabled";

    const stackProps = defaultProps(props?.stackProps || {}, {
        sx: {
            gap: 1.5,
            padding: 2,
            borderRadius: 0.75,
            flexDirection: "row",
            alignItems: "flex-start",
            ...variantStyles[variant],
        },
    });

    const iconProps = defaultProps(props?.iconProps || {}, {
        component: variantIcons[variant],
        sx: {
            fontSize: 22,
        },
    });

    return (
        <Stack {...stackProps}>
            <SvgIcon {...iconProps} />
            <AlertTextBox {...props.alertTextBoxProps} />
            {props.rightSlot}
        </Stack>
    );
}

export default AlertCard;
